
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    OCTAPPROACH_ACTION,
    ALL_OCTAPPROACH,
    ALL_OCTCLUBSPEED,
    ADD_OCTAPPROACH,
    FETCH_OCTAPPROACH,
    EDIT_OCTAPPROACH,
    DELETE_OCTAPPROACH,
    FETCH_OCTAPPROACHCHART,
    FETCH_APPROACHSHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Course Approach Actions
 */

    export const allOCTApproach = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: OCTAPPROACH_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getoncourseapproach', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTAPPROACH, payload: alldata });
            });
        }        
    
    }

    export const studentOCTApproach = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }
    
        return (dispatch) => { 
            dispatch({ type:OCTAPPROACH_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentoncourseapproach', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTAPPROACH, payload: alldata }); 
            });
        
        }
    }

    export const allOCTClubSpeed = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: OCTAPPROACH_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getoncourseclubspeed', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTCLUBSPEED, payload: alldata });
            });
        }        
    
    }

    export const addOCTApproach = (data, sepmore) => {
        var id= data.target.student.value;
        var payload = {
            "totval": 1,
            "student_1": data.target.student.value,
            "sgdate": data.target.seldate.value,
            "shtot_1": sepmore,
        }    
               
    
        for (let i = 0; i < sepmore; i++) {
    
            var distance = 'distance_' + i;
            var distanceval = data.target[distance].value;
            var right = 'right_' + i;
            var rightval = data.target[right].value;
            var left = 'left_' + i;
            var leftval = data.target[left].value;
            var short = 'short_' + i;
            var shortval = data.target[short].value;
            var long = 'long_' + i;
            var longval = data.target[long].value;
            var area = 'area_' + i;
            var areaval = data.target[area].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var sepopt = 'putt_' + i;
            var seoptval = data.target[sepopt].value;
            var septravel = 'missedgreen_' + i;
            var setrvalval = data.target[septravel].value;
    
            var adval = i + 1;
            var distadd = 'shottype_1_' + adval;
            var rightadd = 'right_1_' + adval;
            var leftadd = 'left_1_' + adval;
            var shortadd = 'short_1_' + adval;
            var longadd = 'long_1_' + adval;
            var areaadd = 'area_1_' + adval;
            var contadd='contact_1_'+adval;
            var sepoptadd = 'putt_1_' + adval;
            var septraveladd = 'dhg_1_' + adval;
    
            payload[distadd] = distanceval;
            payload[rightadd] = rightval;
            payload[leftadd] = leftval;
            payload[shortadd] = shortval;
            payload[longadd] = longval;
            payload[areaadd] = areaval;
            payload[contadd]=contactval;
            payload[sepoptadd] = seoptval;
            payload[septraveladd] = setrvalval;
    
        }

        return (dispatch) => {
            dispatch({ type: OCTAPPROACH_ACTION, });
            return axios.post(AppConfig.apiurl + '/api/addoncourseapproach', payload, { headers: AuthHeader.header })
                .then(response => {
                    var resdata = response.data;
                    if (resdata.status === 1) {
                        studentOCTApproach(id, '', '')(dispatch);   
                        fetchOCTApproachChart(id, '', '', '', '', '')(dispatch);
                        NotificationManager.success(resdata.message);
                        dispatch({ type: ADD_OCTAPPROACH });
                    }
                    return Promise.resolve(resdata);
    
                });
    
        }
    }

    export const fetchOCTApproach = (id, date) => {

        var payload = {
            "id": id,
            "date": date
        }
        return (dispatch) => {
            dispatch({ type: OCTAPPROACH_ACTION, });
            return axios.post(AppConfig.apiurl + '/api/getocadetails', payload, { headers: AuthHeader.header })
                .then(response => {
                    var resdata = response.data;
                    if (resdata.status === 1) {
                        dispatch({ type: FETCH_OCTAPPROACH, payload: resdata.data });
                    }
                    return Promise.resolve(resdata);
    
                });
    
        }
    }

    export const editOCTApproach = (data, sepmore, oldate) => {
        var id=data.target.student.value;
        var payload = {
            "totval": 1,
            "student": data.target.student.value,
            "sgdate": data.target.seldate.value,
            "shtot_1": sepmore,
            "olddate": oldate,
        }    
               
    
        for (let i = 0; i < sepmore; i++) {
    
            var distance = 'distance_' + i;
            var distanceval = data.target[distance].value;
            var right = 'right_' + i;
            var rightval = data.target[right].value;
            var left = 'left_' + i;
            var leftval = data.target[left].value;
            var short = 'short_' + i;
            var shortval = data.target[short].value;
            var long = 'long_' + i;
            var longval = data.target[long].value;
            var area = 'area_' + i;
            var areaval = data.target[area].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var sepopt = 'putt_' + i;
            var seoptval = data.target[sepopt].value;
            var septravel = 'missedgreen_' + i;
            var setrvalval = data.target[septravel].value;
    
            var adval = i + 1;
            var distadd = 'shottype_1_' + adval;
            var rightadd = 'right_1_' + adval;
            var leftadd = 'left_1_' + adval;
            var shortadd = 'short_1_' + adval;
            var longadd = 'long_1_' + adval;
            var areaadd = 'area_1_' + adval;
            var contadd='contact_1_'+adval;
            var sepoptadd = 'putt_1_' + adval;
            var septraveladd = 'dhg_1_' + adval;
    
            payload[distadd] = distanceval;
            payload[rightadd] = rightval;
            payload[leftadd] = leftval;
            payload[shortadd] = shortval;
            payload[longadd] = longval;
            payload[areaadd] = areaval;
            payload[contadd]=contactval;
            payload[sepoptadd] = seoptval;
            payload[septraveladd] = setrvalval;
    
        }

        return (dispatch) => {
            dispatch({ type: OCTAPPROACH_ACTION, });
            return axios.post(AppConfig.apiurl + '/api/editoncourseapproach', payload, { headers: AuthHeader.header })
                .then(response => {
                    var resdata = response.data;
                    if (resdata.status === 1) {
                        studentOCTApproach(id, '', '')(dispatch);   
                        fetchOCTApproachChart(id, '', '', '', '', '')(dispatch);
                        NotificationManager.success(resdata.message);
                        dispatch({ type: EDIT_OCTAPPROACH });
                    }
                    return Promise.resolve(resdata);
    
                });
    
        }
    }

    export const deleteOCTApproach = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }        
        return (dispatch) => { 
            dispatch({ type:OCTAPPROACH_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteoncourseapproach', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    studentOCTApproach(id, '', '')(dispatch);                   
                    fetchOCTApproachChart(id, '', '', '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_OCTAPPROACH});                    
                }                
                
            });
        
        }
    }

    export const fetchOCTApproachChart = (id, start, end, distance, area, contact) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "distance":distance,
            "area":area             
        }

        return (dispatch) => { 
            dispatch({ type:OCTAPPROACH_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onapproachreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                var approach=resdata.approach;
                dispatch({ type: FETCH_OCTAPPROACHCHART, payload: approach}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchApproachShotChart = (id, start, end, distance, area, contact, section) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "distance":distance,
            "area":area,
            "section":section            
        }

        return (dispatch) => { 
            dispatch({ type:OCTAPPROACH_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onapproachshotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_APPROACHSHOTCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }